import React from "react";
import TeaserCTA from "./TeaserCTA";

/**
 * TeaserHero — the top of every logged-out gamification page.
 * Eyebrow + H1 + sub + the working Sign-Up / Log-in CTA pair, on the felt-green
 * / gold brand surface. Optional `media` renders alongside the copy on wide
 * viewports; `children` render below the CTA (e.g. a small trust row).
 *
 * Props:
 *   eyebrow?   node    small kicker above the title
 *   title      node    the H1
 *   subtitle?  node    supporting line
 *   media?     node    optional visual (image/illustration) — pass an existing asset only
 *   children?  node    extra content under the CTA
 *   align?     "start" | "center"  default "start"
 *   className? str
 *   ...cta            all TeaserCTA props (setModalSignUpPropsData, setModalLoginPropsData, onSignUp, onLogin, labels, showLogin)
 */
const TeaserHero = ({
  eyebrow,
  title,
  subtitle,
  media,
  children,
  align = "start",
  className = "",
  ...cta
}) => {
  return (
    <section
      className={
        "teaser-hero" +
        ` teaser-hero--${align}` +
        (media ? " teaser-hero--split" : "") +
        (className ? ` ${className}` : "")
      }
    >
      <div className="teaser-hero__copy">
        {eyebrow ? <span className="teaser-eyebrow">{eyebrow}</span> : null}
        {title ? <h1 className="teaser-hero__title">{title}</h1> : null}
        {subtitle ? <p className="teaser-hero__sub">{subtitle}</p> : null}
        <TeaserCTA size="lg" align={align} {...cta} />
        {children ? <div className="teaser-hero__extra">{children}</div> : null}
      </div>
      {media ? <div className="teaser-hero__media">{media}</div> : null}
    </section>
  );
};

export default TeaserHero;
